import React from 'react';

// third party imports
import PropTypes from 'prop-types';

export default function SvgIcon({ src, alt, sx, width, className }) {
  return <img className={className} src={src} alt={alt ? alt : 'icon'} style={{ ...sx }} />;
}

SvgIcon.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  sx: PropTypes.object,
  width: PropTypes.number,
  className: PropTypes.string
};
